import { render } from "./LinkTables.vue?vue&type=template&id=607ba5fc"
import script from "./LinkTables.vue?vue&type=script&lang=js"
export * from "./LinkTables.vue?vue&type=script&lang=js"

import "./LinkTables.vue?vue&type=style&index=0&id=607ba5fc&lang=css"

import exportComponent from "/Users/aml/Projects/dashboardcopy2/fnbxv21-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__